<div class="npdc-title">
  <h1>Plankton expeditions</h1>
</div>

<p>
  This is the list of expeditions associated with the
  <a routerLink="/dataset/{{ planktonDatasetId }}"> Marine plankton biodiversity </a>
  dataset.
</p>

<div class="npdc-search">
  <div class="npdc-search__input">
    <div class="npdc-search__input__prefix">
      <mat-icon>search</mat-icon>
    </div>
    <input
      type="search"
      placeholder="Search in expedition names …"
      [value]="q()"
      (search)="onSearchEvent($event)"
      (keydown.enter)="onSearchEvent($event)"
    />
  </div>
</div>

<app-list [resource]="response">
  @if (!response.error()) {
    <mat-nav-list>
      @for (exp of response.value()?.items; track exp.name) {
        <a mat-list-item routerLink="/plankton/event/" [queryParams]="{ expedition: exp.name }">
          <mat-icon matListItemIcon>directions_boat</mat-icon>
          <span matListItemTitle>{{ exp.name }}</span>
          <span matListItemLine>
            {{ exp.firstDate }}
            @if (exp.firstDate !== exp.lastDate) {
              to {{ exp.lastDate }}
            }
          </span>
          <span matListItemLine>
            @if (exp.eventCount === 1) {
              1 event
            } @else {
              {{ exp.eventCount }} events
            }
          </span>
        </a>
      }
    </mat-nav-list>

    <mat-paginator
      showFirstLastButtons
      (page)="onPageEvent($event)"
      [length]="count()"
      [pageIndex]="page()"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[10, 20, 50, 100]"
    >
    </mat-paginator>
  }
</app-list>
